import { render, staticRenderFns } from "./Particles.vue?vue&type=template&id=1445104f&scoped=true&"
import script from "./Particles.vue?vue&type=script&lang=ts&"
export * from "./Particles.vue?vue&type=script&lang=ts&"
import style0 from "./Particles.vue?vue&type=style&index=0&id=1445104f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445104f",
  null
  
)

export default component.exports